import { Section } from 'components/Shared/Layout';
import { NO_ELEMENT } from 'utils';
import styles from './styles.scss';

interface MergedProps {
  header: string;
  longDescription: string;
}

export const InfoBlock = ({ header, longDescription }: MergedProps) =>
  longDescription ? (
    <Section appearance="secondary" className={styles.infoBlock}>
      <h2>{header}</h2>
      <div className={styles.description} dangerouslySetInnerHTML={{ __html: longDescription }} />
    </Section>
  ) : (
    NO_ELEMENT
  );
